import { Component, Input, OnInit } from '@angular/core';
import { Project } from './../../../interfaces/project';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { isValidEmailAddress } from '../../../shared/utils/bb-email-validator.util';

@Component({
	selector: 'bb-sidebar-details',
	templateUrl: './bb-sidebar-details.component.html',
	styleUrls: ['./bb-sidebar-details.component.scss']
})
export class BbSidebarDetailsComponent implements OnInit {
	@Input() project: Project;
	@Input() mainMediaClip: Mediaclip;
	createdByIsEmailAddress = false;
	updatedByIsEmailAddress = false;

	constructor(
	) { }

	ngOnInit() {
		this.createdByIsEmailAddress = isValidEmailAddress(this.project.createdBy);
		this.updatedByIsEmailAddress = isValidEmailAddress(this.project.updatedBy);
	}
}
